import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { AdminSideBarLinks } from 'data';

const AdminSideBar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('admin_access_token');
        navigate('/admin/login');
    };

    return (
        <div className="h-full w-[240px] flex-shrink-0" style={{ background: 'linear-gradient(180deg, #1E1B4B 0%, #312E81 100%)' }}>
            <div className="flex flex-col h-full px-4 py-6">
                {/* Logo */}
                <div className="px-3 mb-8">
                    <div className="text-white font-extrabold text-lg tracking-tight">Tipot</div>
                    <div className="text-indigo-300 text-[11px] mt-0.5">Admin Console</div>
                </div>

                {/* Nav links */}
                <nav className="flex flex-col gap-1 flex-1">
                    {AdminSideBarLinks.map((link, index) => {
                        const isBasicLink = link.href === '/admin';
                        const isActive = isBasicLink
                            ? location.pathname === link.href
                            : location.pathname.startsWith(link.href);

                        return (
                            <NavLink
                                key={index}
                                to={link.href}
                                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13px] font-medium transition-all duration-150
                                    ${isActive
                                        ? 'bg-white/15 text-white'
                                        : 'text-indigo-200 hover:bg-white/10 hover:text-white'}`}
                            >
                                <span className="text-base">{link.icon}</span>
                                <span>{link.title}</span>
                            </NavLink>
                        );
                    })}
                </nav>

                {/* Logout */}
                <div className="px-3 pt-4 border-t border-white/10">
                    <button
                        className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-[13px] font-medium text-indigo-300 hover:bg-white/10 hover:text-white transition-all duration-150"
                        onClick={handleLogout}
                    >
                        <span className="text-base">🚪</span>
                        <span>로그아웃</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminSideBar;